// src/locales/en/nav.js
export const nav = {
    dashboard: "Dashboard",
    orders: "Orders",
    onlineOrders: "Online Sales",
    products: "Products",
    inventory: "Inventory",
    procurement: "Procurement",
    users: "User Management",
    shops: "Shops",
    reports: "Reports",
    settings: "Settings",
    logout: "Logout",
    profile: "Profile",
    couriers: "Couriers",
    humanResource: "Human Resource",
}